import CustomPopover, { usePopover } from '@/components/overlays/custom-popover';
import IconButton from '@mui/material/IconButton';
import Iconify from '@/components/media/iconify';
import MenuItem from '@mui/material/MenuItem';
import { m } from 'framer-motion';
import { useCallback } from 'react';
import { varHover } from '@/components/utils/animate';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// ----------------------------------------------------------------------

export default function HelpPopover() {
  const { t } = useTranslation();

  const popover = usePopover();

  const handleGoToHelpCenter = useCallback(() => {
    window.open('https://help.marketplace.orion.global/', '_blank', 'noopener,noreferrer');
    popover.onClose();
  }, [popover]);

  const handleGoToContactForm = useCallback(() => {
    window.open('https://forms.gle/3u12Amiw9nHcnwrq9', '_blank', 'noopener,noreferrer');
    popover.onClose();
  }, [popover]);

  return (
    <>
      <Tooltip title={t('Help')}>
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          onClick={popover.onOpen}
          sx={{
            width: { xs: 32, sm: 36, md: 40 },
            height: { xs: 32, sm: 36, md: 40 },
            p: { xs: 0.5, sm: 0.75, md: 1 },
            ...(popover.open && {
              bgcolor: 'action.selected',
            }),
          }}
        >
          <HelpOutlineIcon sx={{ color: 'text.secondary' }} />
        </IconButton>
      </Tooltip>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 160 }}>
        <MenuItem onClick={handleGoToHelpCenter}>
          <Iconify
            icon={'solar:notebook-minimalistic-outline'}
            sx={{
              borderRadius: 0.65,
              width: { xs: 20, sm: 24, md: 28 },
              mr: 1,
            }}
          />
          {t('Help center')}
        </MenuItem>

        <MenuItem onClick={handleGoToContactForm}>
          <Iconify
            icon={'solar:letter-outline'}
            sx={{
              borderRadius: 0.65,
              width: { xs: 20, sm: 24, md: 28 },
              mr: 1,
            }}
          />
          {t('Report Issue')}
        </MenuItem>
      </CustomPopover>
    </>
  );
}
